import type { TypedAction } from "../../../../generic/redux/TypedRedux";

import { TIMELINE_UPDATE_REQUESTED } from "./TimelineActionTypes";
import type { TimeRange } from "./TimeRange";

export interface TimelineUpdateRequestedData {
	timeRange?: TimeRange;
	timestamp?: Date;
}

export type TimelineUpdateRequested = TimelineUpdateRequestedData & TypedAction<typeof TIMELINE_UPDATE_REQUESTED>;

export function timelineUpdateRequested(data: TimelineUpdateRequestedData): TimelineUpdateRequested {
	return {
		type: TIMELINE_UPDATE_REQUESTED,
		...data,
	};
}
